import { useEffect } from 'react';

import { Outlet, useLocation } from 'react-router';
import { ToastContainer } from 'react-toastify';

import { useInitHotJar, useIsMounted, googleAnalytics4 } from '@/_shared';

declare global {
  interface Window {
    previousPage: null | string;
    isDev?: boolean;
  }
}

window.previousPage = null;

export default function Administrator() {
  const hotJarStateChange = useInitHotJar();
  const location = useLocation();

  useEffect(() => {
    hotJarStateChange(location.pathname);
    window.scrollTo(0, 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useIsMounted(() => {
    googleAnalytics4.init();
  });

  return (
    <>
      <Outlet />
      <ToastContainer
        limit={5}
        position="bottom-left"
        autoClose={6000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnHover
        toastClassName="py-6 px-5 rounded-xl text-sm font-sans text-accent-light items-start"
      />
    </>
  );
}
